/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AuthorizationPropertyValueInViewModel } from './authorizationPropertyValueInViewModel';

export interface RegisterAndAuthorizeUserInViewModel { 
    userId?: string;
    applicationId?: number;
    email?: string;
    fullName?: string;
    userType?: number;
    roles?: Array<string>;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; };
}